import { Country } from 'library/ts/model/enums/geo/Country';
import { ISmartTagReadyCallback } from 'tag/ts/smart_tag/interfaces/ISmartTagReadyCallback';
import { Constants } from 'tag/ts/smart_tag/model/Constants';
import { EmbedType } from 'tag/ts/tag/model/type/embed/EmbedType';

// relative load is ON by default
export const DEFAULT_RELATIVE_VALUE: boolean = true;

export const DefaultSmartTagReadyCallback: ISmartTagReadyCallback = {
	env: EmbedType.DESKTOP,
	country: Country.US,
	locale: 'en-us',
	delay: undefined,
	method: Constants.getInstance().FUNCTION_SMART_TAG_ON_READY,
	namespace: undefined,
	payload: {
		relative: DEFAULT_RELATIVE_VALUE
	},
	newRelic: false,
	platformConfig: {
		//	supporting:
		//		Chrome v68+
		//		FF v52+ on Win XP and Vista, v48+ on all other OSes
		//		Safari v9+
		//		Edge v14+
		//	NOT supporting:
		//		IE
		//		Opera
		DEFAULT: {
			CHROME: {
				minVersion: 68
			},
			FIREFOX: {
				minVersion: 48
			},
			SAFARI: {
				minVersion: 9
			},
			EDGE: {
				minVersion: 14
			},
			IE: {
				disable: true
			},
			OPERA: {
				disable: true
			}
		},
		WINDOWS_XP: {
			FIREFOX: {
				minVersion: 52
			}
		},
		WINDOWS_VISTA: {
			FIREFOX: {
				minVersion: 52
			}
		}
	},
	detectAutoplay: true
};